<template>
  <card :title="$t('sections.guarantees.table.title')">
    <base-table :data="getActualGuarantees">
      <el-table-column
        prop="entityName"
        :label="$t('sections.guarantees.table.entityName')"
      />
      <el-table-column
        prop="entityType"
        :label="$t('sections.guarantees.table.entityType')"
      />
      <el-table-column
        prop="actualEMSP"
        :label="$t('sections.guarantees.table.ceme')"
        :formatter="(row) => formatNumber(row.actualEMSP)"
      />
      <el-table-column
        prop="actualCPO"
        :label="$t('sections.guarantees.table.opc')"
        :formatter="(row) => formatNumber(row.actualCPO)"
      />
      <el-table-column
        prop="actualDPC"
        :label="$t('sections.guarantees.table.dpc')"
        :formatter="(row) => formatNumber(row.actualDPC)"
      />
      <el-table-column fixed="right" width="60">
        <template slot-scope="props">
          <div class="d-flex justify-content-center">
            <el-dropdown trigger="click">
              <div class="outline-icon-button">
                <font-awesome-icon icon="fa-regular fa-ellipsis-vertical" />
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <router-link
                    :to="{
                      name: 'Guarantee Detail',
                      params: {
                        id: props.row.entityCode,
                        guarantee: props.row,
                      },
                    }"
                  >
                    {{ $t("sections.guarantees.options")[0] }}
                  </router-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </base-table>
  </card>
</template>
<script>
import { mapGetters } from 'vuex';
import { formatNumber } from '@/utils';

export default {
  name: 'GuaranteesListTable',
  computed: {
    ...mapGetters(['getActualGuarantees']),
  },
  methods: {
    formatNumber(value) {
      return formatNumber(value);
    },
  },
};
</script>
<style lang="scss" scoped></style>
